/** MVP v1.0 is matching-only: no escrow, checkout, or Stripe in the UI. */
export const MVP_ENABLE_CHECKOUT = false;

export const LANG_STORAGE_KEY = 'massunihub-lang';
export const LANG_STORAGE_KEY_LEGACY = 'dibs-lang';
